const embed = {}

embed.init = () => {
    embed.embedTwitter();
    embed.embedInstagram();
    embed.embedTikTok();
}

embed.embedTwitter = () => {
    if ($("blockquote.twitter-tweet").length > 0) {
        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.01,
        };
        let firstTime = true;
        let callback = (entries, observer) => {
            entries.map((entry) => {
                if (entry.isIntersecting && firstTime === true) {
                    firstTime = false;
                    let script = document.createElement('script');
                    let node = document.getElementsByTagName('body')[0];
                    script.type = 'text/javascript';
                    script.defer = true;
                    script.src = 'https://platform.twitter.com/widgets.js';
                    node.appendChild(script);
                    observer.disconnect();
                }
            });
        };
        let observer = new IntersectionObserver(callback, options);
        observer.observe(document.querySelector("blockquote.twitter-tweet"))
    }
}

embed.embedInstagram = () => {
    if ($("blockquote.instagram-media").length > 0) {
        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.01,
        };
        let firstTime = true;
        let callback = (entries, observer) => {
            entries.map((entry) => {
                if (entry.isIntersecting && firstTime === true) {
                    firstTime = false;
                    let script = document.createElement('script');
                    let node = document.getElementsByTagName('body')[0];
                    script.type = 'text/javascript';
                    script.defer = true;
                    script.src = 'https://www.instagram.com/embed.js';
                    node.appendChild(script);
                    observer.disconnect();
                }
            });
        };
        let observer = new IntersectionObserver(callback, options);
        observer.observe(document.querySelector("blockquote.instagram-media"))
    }
}

embed.embedTikTok = () => {
    if ($("blockquote.tiktok-embed").length > 0) {
        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.01,
        };
        let firstTime = true;
        let callback = (entries, observer) => {
            entries.map((entry) => {
                if (entry.isIntersecting && firstTime === true) {
                    firstTime = false;
                    let script = document.createElement('script');
                    let node = document.getElementsByTagName('body')[0];
                    script.type = 'text/javascript';
                    script.defer = true;
                    script.src = 'https://www.tiktok.com/embed.js';
                    node.appendChild(script);
                    observer.disconnect();
                }
            });
        };
        let observer = new IntersectionObserver(callback, options);
        observer.observe(document.querySelector("blockquote.tiktok-embed"))
    }
}

export default embed;